import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { messaging, onForegroundMessage } from "../../services/pushnotification";
import { useIonAlert } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { AppRoutes } from "../../constants/appRoutes";
import { NotificationTypes } from "../../constants/notificationTypes";
import { useAppDispatch } from "../../redux/hooks";
import { fetchRequestItem, fetchRequestList } from "../../redux/actions/request/request";
import { LocalStorageService } from "../../services/localStorageService";
import { setGlobalLoading } from "../../redux/reducers/globalLoading/globalLoading";

export const ForegroundNotification: React.FC = () => {
    const { t } = useTranslation("common");
    const [presentAlert] = useIonAlert();
    const dispatch = useAppDispatch();

    const history = useHistory();

    useEffect(() => {
        const handleMessage = (payload: any) => {
            const notification = payload;
            const args = notification.data.args.split("|");
            let title: string = t("GLOBAL.WARNING");
            let message: string = "";
            const reload = () => {
                dispatch(fetchRequestList());
                dispatch(fetchRequestItem(args[0])).then((response: any) => {
                    !response && history.replace(AppRoutes.REQUEST);
                    dispatch(setGlobalLoading(false));
                });
                history.replace(AppRoutes.REQUEST_DETAILS.replace(":id", args[0]));
            };

            if (NotificationTypes.DOCK_ASSIGNMENT === notification.data.key) {
                message = t("MESSAGES.DOCK_ASSIGNMENT", { arg1: args[1], arg2: args[2] });
            }

            if (NotificationTypes.EXIT === notification.data.key) {
                message = t("MESSAGES.EXIT", { arg1: args[1] });
            }

            if (NotificationTypes.INFO === notification.data.key) {
                title = payload.notification.title;
                message = payload.notification.body;
            }

            presentAlert({
                header: title,
                backdropDismiss: false,
                cssClass: "custom-alert",
                message: message,
                buttons: [
                    {
                        text: t("GLOBAL.ACCEPT"),
                        role: "cancel",
                        handler: reload,
                    },
                ],
            });
        };

        onForegroundMessage(handleMessage);

        return () => {
            onMessage(messaging, handleMessage);
        };
    }, []);
    return <></>;
};
